/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { SecretId } from "../../commons/types/SecretId";
import { WriteSecret } from "./WriteSecret";
export const Secret = core.serialization
    .object({
    id: SecretId,
})
    .extend(WriteSecret);
